<div class="ov-flow open-reporting theme-inner"
     [ngClass]="{'open-reporting': selectedTab === 'Open Reporting', 'stop-work-authority': selectedTab === 'Stop Work Authority', 'safe-harbour': selectedTab === 'Safe Harbour'}">
     <div class="bg-colour">
          <ion-skeleton-text *ngIf="!isFrontImageLoaded || !isBackImageLoaded" animated="true"
               class="img-skelton"></ion-skeleton-text>
          <ng-container>
               <img *ngIf="selectedTab === 'Open Reporting'" (load)="onImageLoad('front')"
                    [class.hide]="!isFrontImageLoaded" src="../assets/img/Open-reporting-front.jpg"
                    alt="Open Reporting" />

               <img *ngIf="selectedTab === 'Open Reporting'" (load)="onImageLoad('back')"
                    [class.hide]="!isBackImageLoaded" src="../assets/img/Open-reporting-back.jpg"
                    alt="Open Reporting" />

               <img *ngIf="selectedTab === 'Stop Work Authority'" (load)="onImageLoad('front')"
                    [class.hide]="!isFrontImageLoaded" src="../assets/img/Stop-work-front.jpg"
                    alt="Stop Work Authority" />

               <img *ngIf="selectedTab === 'Stop Work Authority'" (load)="onImageLoad('back')"
                    [class.hide]="!isBackImageLoaded" src="../assets/img/Stop-work-back.jpg"
                    alt="Stop Work Authority" />

               <pinch-zoom class="full-screen"
                    *ngIf="selectedTab === 'Safe Harbour' && !isDesktop; else safeHarbourDesktop">
                    <img (load)="onImageLoad('front')" [class.hide]="!isFrontImageLoaded"
                         src="../assets/img/Safe-Harbour.jpg" />
               </pinch-zoom>

               <ng-template #safeHarbourDesktop>
                    <img *ngIf="selectedTab === 'Safe Harbour'" (load)="onImageLoad('front')"
                         [class.hide]="!isFrontImageLoaded" src="../assets/img/Safe-Harbour.jpg" alt="Safe Harbour" />
               </ng-template>
          </ng-container>
     </div>
</div>